<div class="inner" *ngIf="(route.params | async)?.address as address" [class.loading]="loading" 
  [class]="themeSvc.theme$ | async">

  <div class="header-wrapper">
    <div>
      <h1 i18n>Account Details</h1>
      <div class="subhead-wrapper">
        <h2 *ngIf="address">
          <div>
            <a [href]="'https://etherscan.io/address/' + address" target="_blank">
              <app-wallet-address [address]="address" class="pink"></app-wallet-address>
              
              <ng-container *ngIf="address == TOKENWORKS_ADDRESS.toLowerCase()">
                <app-marketplace-icons type="tokenworks" size="3rem" contextClass="dashboard"></app-marketplace-icons>
              </ng-container>
              <ng-container *ngIf="address == PUNKAUCTION_ADDRESS.toLowerCase()">
                <app-marketplace-icons type="punkauction" size="3rem" contextClass="dashboard"></app-marketplace-icons>
              </ng-container>
            </a>
            <span class="balance-badge" *ngIf="(walletBalance$ | async) as balance">
              {{ balance }}Ξ
            </span>
          </div>
          <div class="stash-address-row" *ngIf="environment.featureFlags?.STASH_BID_SUPPORT !== false && (stashAddress$ | async) as stashAddress">
            <span class="stash-prefix">L&nbsp;</span>
            <a
              [href]="'https://etherscan.io/address/' + stashAddress"
              target="_blank"
              rel="noopener noreferrer">
              <app-wallet-address [address]="stashAddress" [maxVisibleChars]="14"></app-wallet-address>
            </a>

            <ng-container *ngIf="(stashDeployed$ | async) === false">
              <span class="no-stash-msg">
                This user hasn’t created a stash yet
              </span>
            </ng-container>

            <ng-container *ngIf="(stashDeployed$ | async) === true">
              <span class="balance-badge" *ngIf="(stashBalance$ | async) as balance">
                {{ balance }}Ξ
              </span>
            </ng-container>
          </div>
        </h2>
        <button #shareButton (click)="share(shareButton)" style="margin-right: 1rem;">Share Live User Card</button>
        <button 
          *ngIf="environment.collection === 'cryptopunks'"
          (click)="openCreateOwnerBid(address)">Create Owner Bid</button>
      </div>
    </div>
    <div>
      <app-ens-metadata [address]="address" />
    </div>
  </div>

  <div class="details-wrapper">
    <div>
      <div class="label">Total {{ environment.tokenName }}s Owned</div>
      <div class="value" *ngIf="calcs.punksOwned || calcs.punksOwned === 0; else dash">
        {{ calcs.punksOwned | number }}

        <span *ngIf="calcs.wrappedOwned">
          + 
          {{ calcs.wrappedOwned }}
          wrapped punks
        </span>
      </div>
    </div>

    <div>
      <!-- {{ calcs.spent }} -- {{ calcs.spentUSD }} -->
      <div class="label">Total Amount Spent Buying {{ environment.tokenName }}s</div>
      <div class="value" *ngIf="calcs.spent; else dash">
        {{ calcs.spent | weiToEth | formatCash }}Ξ
        <ng-container *ngIf="calcs.spentUSD as usd">
          (${{ usd | formatCash }})
        </ng-container>
      </div>
    </div>

    <div>
      <div class="label">Total Amount Earned Selling {{ environment.tokenName }}s</div>
      <div class="value" *ngIf="calcs.earned; else dash">
        {{ calcs.earned | weiToEth | formatCash }}Ξ
        <ng-container *ngIf="calcs.earnedUSD as usd">
          (${{ usd | formatCash }})
        </ng-container>
      </div>
    </div>

    <div>
      <div class="label">{{ environment.tokenName }}s for Sale by this Account</div>
      <div class="value" *ngIf="calcs.listed; else dash">{{ calcs.listed | number }}</div>
    </div>

    <div>
      <div class="label">{{ nativeBidTypeLabelPlural }} On Owned {{ environment.tokenName }}s</div>
      <div class="value" *ngIf="calcs.punksWithBids; else dash">{{ calcs.punksWithBids | number }}</div>
    </div>

    <div>
      <div class="label">Current {{ nativeBidTypeLabelPlural }} Placed By This Account</div>
      <div class="value" *ngIf="calcs.placedBids; else dash">{{ calcs.placedBids | number }}</div>
    </div>

    <div>
      <div class="label">Value of {{ nativeBidTypeLabelPlural }} On Owned {{ environment.tokenName }}s</div>
      <div class="value" *ngIf="calcs.bidsReceived; else dash">{{ calcs.bidsReceived | weiToEth | formatCash }}Ξ</div>
    </div>

    <div>
      <div class="label">Value of Current {{ nativeBidTypeLabelPlural }} Placed</div>
      <div class="value" *ngIf="calcs.bids; else dash">{{ calcs.bids | weiToEth | formatCash }}Ξ</div>
    </div>

    <ng-container *ngIf="environment.featureFlags?.STASH_BID_SUPPORT !== false">
      <div>
        <div class="label">Stash Bids On Owned {{ environment.tokenName }}s</div>
        <div class="value" *ngIf="calcs.stashPunksWithBids; else dash">{{ calcs.stashPunksWithBids | number }}</div>
      </div>

      <div>
        <div class="label">Current Stash Bids Placed By This Account</div>
        <div class="value" *ngIf="calcs.stashPlacedBids; else dash">{{ calcs.stashPlacedBids | number }}</div>
      </div>


      <div>
        <div class="label">Value of Current Stash Bids Placed</div>
        <div class="value" *ngIf="calcs.stashBids; else dash">{{ calcs.stashBids | weiToEth | formatCash }}Ξ</div>
      </div>
    </ng-container>

    <ng-template #dash>
      <div class="value">---</div>
    </ng-template>
  </div>

  <ng-container *ngIf="(isUserConnected && userAddress && (route.params | async)?.address === userAddress) ? (proxyPunks$ | async) : (owned$ | async) as owned">
    <section class="owned">
      <h3>{{ owned.length }} {{ environment.tokenName }}s Owned</h3>
      
      <div class="grid-wrapper">
        <div *ngFor="let punk of owned; index as i">
          <!-- {{ punk | json }} -->
          <ng-container *ngTemplateOutlet="punkItem; context: {
            $implicit: punk,
            hideLabels: true,
            showWrapStatus: true,
            idx: i
          }"></ng-container>
        </div>
      </div>
    </section>

    <section class="listings" *ngIf="owned | filter: 'listings' as listings">
      <h3>{{ listings.length }} {{ environment.tokenName }}s for Sale by this Account</h3>
      <div class="grid-wrapper">
        <ng-container *ngFor="let listing of listings; index as i">
          <ng-container *ngTemplateOutlet="punkItem; context:{
            $implicit: listing,
            labelType: 'listings',
            idx: i
          }"></ng-container>
        </ng-container>
      </div>
    </section>

    <section class="bids" *ngIf="owned | filter: 'bids' as owned">
      <h3>{{ owned.length }} {{ nativeBidTypeLabelPlural }} For {{ environment.tokenName }}s Owned by this Account</h3>
      <div class="grid-wrapper">
        <ng-container *ngFor="let punk of owned; index as i">
          <!-- {{ bid | json }} -->
          <ng-container *ngTemplateOutlet="punkItem; context:{
            $implicit: punk,
            labelType: 'bids',
            idx: i
          }"></ng-container>
        </ng-container>
      </div>
    </section>
  </ng-container>

  <section class="bids" *ngIf="bids$ | async as bids">
    <h3>{{ bids.length }} {{ nativeBidTypeLabelPlural }} Placed by this Account</h3>
    <div class="grid-wrapper">
      <ng-container *ngFor="let bid of bids; index as i">
        <!-- {{ bid | json }} -->
        <ng-container *ngTemplateOutlet="punkItem; context:{
          $implicit: bid,
          labelType: 'bids',
          forceWrapped: true,
          idx: i,
          shallowValue: true,
          eventUsd: true
        }"></ng-container>
      </ng-container>
    </div>
  </section>

  <ng-container *ngIf="environment.featureFlags?.STASH_BID_SUPPORT !== false && (stashBidsReceived$ | async) as stashBidsReceived">
    <section class="stash-bids-received" *ngIf="stashBidsReceived.length > 0">
      <h3>{{ stashBidsReceived.length }} Incoming Stash Bids For this Account</h3>
      <app-stash-bids-table 
        [bids]="stashBidsReceived" 
        [showFilters]="false" 
        [showPagination]="true"
        [showPunksColumn]="true"
        [showAcceptButton]="(showAcceptButton$ | async) === true"
        [canAcceptBidFn]="canAcceptStashBid"
        (acceptBid)="onAcceptStashBid($event)"
        (copyBid)="openCopyBidModal($event)">
      </app-stash-bids-table>
    </section>
  </ng-container>

  <ng-container *ngIf="environment.featureFlags?.STASH_BID_SUPPORT !== false && (stashBidsPlaced$ | async) as stashBidsPlaced">
    <section class="bids">
      <div class="section-title-row">
        <h3>{{ stashBidsPlaced.length }} Outgoing Stash Bids Placed for this Account</h3>
        <div class="stash-outgoing-actions">
          <button
            *ngIf="(showAcceptButton$ | async) === true && stashBidsPlaced.length > 0"
            type="button"
            class="cancel-all-stash-bids-btn"
            [disabled]="outgoingCancelInProgress"
            (click)="cancelAllOutgoingStashBids(stashBidsPlaced)">
            {{ outgoingCancelInProgress ? 'Canceling...' : 'Cancel all active bids' }}
          </button>
          <div class="toggle-wrapper inline-archive-toggle">
            <div class="sales-only-toggle" (click)="onDisplayArchivedStashBidsToggle()">
              <div class="label">Hide archived bids</div>
              <div class="toggle" [class.on]="!displayArchivedStashBids">
                <div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ng-container *ngIf="stashBidsPlaced.length > 0; else noStashBidsPlaced">
        <app-stash-bids-table
          [bids]="stashBidsPlaced"
          [showFilters]="false"
          [preserveServerOrder]="displayArchivedStashBids"
          [showPagination]="true"
          [showPunksColumn]="true"
          [punkIdsDisplayMode]="'targeted'"
          [showStatusColumn]="true"
          [showCancelButton]="(showAcceptButton$ | async) === true"
          [canCancelBidFn]="canCancelStashBid"
          (cancelBid)="onCancelOutgoingStashBid($event)"
          (copyBid)="openCopyBidModal($event)">
        </app-stash-bids-table>
      </ng-container>
      <ng-template #noStashBidsPlaced>
        <div class="stash-bids-empty-state">
          <p>No stash bids found for this account.</p>
        </div>
      </ng-template>
    </section>
  </ng-container>

  <ng-container *ngIf="punksmarketBidsEnabled() && (punksmarketBidsPlaced$ | async) as pmBidsPlaced">
    <section class="bids punksmarket-bids-section" *ngIf="pmBidsPlaced.length > 0">
      <h3>{{ pmBidsPlaced.length }} <app-on-chain-bid-label>{{ onChainBidOutgoingSectionTitle }}</app-on-chain-bid-label></h3>
      <app-stash-bids-table
        [bids]="pmBidsPlaced"
        [showFilters]="false"
        [showPagination]="true"
        [showPunksColumn]="true"
        [punkIdsDisplayMode]="'targeted'"
        [showExpiresColumn]="false"
        [showCancelButton]="(showAcceptButton$ | async) === true"
        [canCancelBidFn]="canCancelPunksmarketBid"
        (cancelBid)="onCancelPunksmarketBid($event)">
      </app-stash-bids-table>
    </section>
  </ng-container>

  <section class="bought" *ngIf="bought$ | async as bought">
    <h3>{{ bought.length }} {{ environment.tokenName }}s Bought by This Account</h3>
    <div class="grid-wrapper">
      <ng-container *ngFor="let event of bought; index as i">
        <ng-container *ngTemplateOutlet="punkItem; context:{
          $implicit: event,
          idx: i,
          shallowValue: true,
          showSaleDate: true,
          forceWrapped: true,
          eventUsd: true,
          showSaleDebug: true,
          showSaleIcons: true
        }"></ng-container>
      </ng-container>
    </div>
  </section>

  <section class="sold" *ngIf="sold$ | async as sold">
    <h3>{{ sold.length }} {{ environment.tokenName }}s Sold by This Account</h3>
    <div class="grid-wrapper">
      <ng-container *ngFor="let event of sold; index as i">
        <ng-container *ngTemplateOutlet="punkItem; context:{
          $implicit: event,
          idx: i,
          shallowValue: true,
          showSaleDate: true,
          forceWrapped: true,
          eventUsd: true,
          showSaleDebug: true,
          showSaleIcons: true
        }"></ng-container>
      </ng-container>
    </div>
  </section>
</div>

<ng-template #punkItem
  let-item
  let-forceWrapped="forceWrapped"
  let-bgColor="bgColor"
  let-hideLabels="hideLabels"
  let-labelType="labelType"
  let-shallowValue="shallowValue"
  let-showSaleDate="showSaleDate"
  let-eventUsd="eventUsd"
  let-showSaleDebug="showSaleDebug"
  let-showSaleIcons="showSaleIcons"
  let-showWrapStatus="showWrapStatus">

  <div class="item">
    <ng-container *ngIf="!showWrapStatus">
      <ng-container
        *ngIf="!item.wrapped && item.listing?.nativePunksmarket && environment.collection === 'cryptopunks-v1'">
        <a
          [href]="punksmarketPunkUrl(item.id || item.tokenId)"
          target="_blank"
          rel="noopener noreferrer"
          class="listing-source v1-sale-source"
          title="PunksMarket native listing">
          <img src="/images/larvalabs.svg" alt="Native V1 (Larva Labs)" />
        </a>
      </ng-container>

      <ng-container
        *ngIf="showSaleIcons && isDashboardPunksmarketNativeSale(item) && environment.collection === 'cryptopunks-v1'">
        <a
          [href]="punksmarketPunkUrl(item.tokenId || item.id)"
          target="_blank"
          rel="noopener noreferrer"
          class="listing-source v1-sale-source"
          title="PunksMarket native sale">
          <img src="/images/larvalabs.svg" alt="Native V1 (Larva Labs)" />
        </a>
      </ng-container>

      <ng-container *ngIf="item.listing?.source as source">
        <a
          *ngIf="source.icon"
          [href]="source.name === 'NFTX' ? 'https://v2.nftx.io/vault/' + environment.nftxVaultAddress : source.url"
          target="_blank"
          rel="noopener noreferrer"
          class="listing-source"
          [class.opensea]="source.name === 'OpenSea'"
          [class.blur]="source.name === 'Blur'">

          <img
            [src]="source.name === 'nftx.io' ? '/assets/nftx.svg' : source.icon"
            [alt]="source.name"
          />
        </a>
      </ng-container>

      <div
        *ngIf="item.fromAccount?.id === tokenworksAddressLower || item.toAccount?.id === tokenworksAddressLower || item.listing?.punk?.owner?.id === tokenworksAddressLower"
        class="listing-source">
        <app-marketplace-icons type="tokenworks" size="2rem" contextClass="grid-view"></app-marketplace-icons>
      </div>

      <div
        *ngIf="item.fromAccount?.id === punkauctionAddressLower || item.toAccount?.id === punkauctionAddressLower || item.listing?.punk?.owner?.id === punkauctionAddressLower"
        class="listing-source punkauction">
        <app-marketplace-icons type="punkauction" size="2rem" contextClass="grid-view"></app-marketplace-icons>
      </div>

      <ng-container *ngIf="showSaleIcons && item.platform === 'blur' && item.listing?.source?.name !== 'Blur'">
        <a
          href="https://blur.io"
          target="_blank"
          rel="noopener noreferrer"
          class="listing-source blur">
          <img src="https://blur.io/favicons/180.png" alt="Blur" />
        </a>
      </ng-container>

      <ng-container *ngIf="showSaleIcons && item.platform === 'opensea' && item.listing?.source?.name !== 'OpenSea'">
        <a
          href="https://opensea.io"
          target="_blank"
          rel="noopener noreferrer"
          class="listing-source opensea">
          <img src="/images/opensea-logo.svg" alt="OpenSea" />
        </a>
      </ng-container>

      <ng-container *ngIf="showSaleIcons && isDashboardNativeV1SaleIcon(item)">
        <span class="listing-source v1-sale-source" title="Native V1 sale">
          <img src="/images/larvalabs.svg" alt="Native V1 (Larva Labs)" />
        </span>
      </ng-container>

      <ng-container *ngIf="showSaleIcons && isDashboardErc721StashSaleIcon(item)">
        <span class="listing-source v1-sale-source" title="ERC721 Stash sale">
          <img src="/images/larvalabs.svg" alt="Native V1 (Larva Labs)" />
        </span>
      </ng-container>

      <ng-container *ngIf="showSaleIcons && isDashboardWrappedV1SaleIcon(item)">
        <span class="listing-source v1-sale-source wrapped-v1" title="Wrapped V1 sale">
          <img src="/assets/punkv1.svg" alt="Wrapped V1 sale" />
        </span>
      </ng-container>

      <ng-container *ngIf="showSaleIcons && environment.collection === 'cryptopunks' && item.wrapped && !item.c721wrapped && item.platform !== 'blur' && item.platform !== 'opensea'">
        <span class="listing-source wrapped" title="Wrapped sale">
          <ng-template [ngTemplateOutlet]="wrappedLogo" />
        </span>
      </ng-container>

      <ng-container *ngIf="showSaleIcons && environment.collection === 'cryptopunks' && item.c721wrapped && item.platform !== 'blur' && item.platform !== 'opensea'">
        <span class="listing-source wrapped c721" title="C721 wrapped sale">
          <ng-template [ngTemplateOutlet]="wrappedC721Logo" />
        </span>
      </ng-container>
    </ng-container>

    <a
      class="item-link"
      [routerLink]="item.listing?.source?.internal ? item.listing?.source?.internal : ['/', 'details', (item.id || item.tokenId)]"
      [href]="item.listing?.source?.internal ? item.listing?.source?.internal : ['/details/' + (item.id || item.tokenId)]">

      <div
        class="image-wrapper"
        [class.bid]="!showWrapStatus && ((item.bid && (labelType === 'bids' || bgColor)) || (shallowValue && labelType === 'bids'))"
        [class.listing]="!showWrapStatus && item.listing && !item.listing?.nativePunksmarket && ((item.listing && (labelType === 'listings' || bgColor)) || (shallowValue && labelType === 'listing'))"
        [class.native-v1-listing]="!showWrapStatus && item.listing?.nativePunksmarket && (labelType === 'listings' || bgColor)"
        [class.wrapped]="showWrapStatus ? isOwnedPunkWrapped(item) : item.wrapped"
        [class.c721wrapped]="item.c721wrapped">

        <div
          *ngIf="showSaleDebug && showSaleDebugJson"
          class="debug-icon"
          (click)="copySaleJson(item, $event)"
          title="Copy sale event JSON to clipboard">
          (i)
        </div>

        <img
          [src]="dataSvc.staticUrl + dataSvc.tokenImagePath + ((item.id || item.tokenId) | tokenIdParse) + '.svg'"
          width="50"
          height="50"
        />
      </div>
    </a>

    <div
      *ngIf="!hideLabels"
      class="labels-wrapper">

      <!-- <div class="label">#{{ (item.id || item.tokenId) }}</div> -->

      <ng-container *ngIf="labelType === 'listings'">
        <ng-container *ngIf="item.listing as listing">
          <p i18n>
            {{ (listing.value | weiToEth) | formatCash }}Ξ
            @if (eventUsd && listing.usd && listing.usd !== '0') {
              <br />${{ ((listing.value | weiToEth) | usd : listing.usd) | formatCash }}
            } @else if (!eventUsd) {
              <br />${{ ((listing.value | weiToEth) * ((dataSvc.usd$ | async) || 0)) | formatCash }}
            }
          </p>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="labelType === 'bids'">
        <ng-container *ngIf="item.bid as bid">
          <p i18n>
            {{ (bid.value | weiToEth) | formatCash }}Ξ
            @if (eventUsd && bid.usd && bid.usd !== '0') {
              <br />${{ ((bid.value | weiToEth) | usd : bid.usd) | formatCash }}
            } @else if (!eventUsd) {
              <br />${{ ((bid.value | weiToEth) * ((dataSvc.usd$ | async) || 0)) | formatCash }}
            }
          </p>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="shallowValue && showSaleDate">
        <p class="sale-value" i18n>
          {{ (item.value | weiToEth) | formatCash }}Ξ
          @if (eventUsd && item.usd && item.usd !== '0') {
            (${{ ((item.value | weiToEth) | usd : item.usd) | formatCash }})
          } @else if (!eventUsd) {
            (${{ ((item.value | weiToEth) * ((dataSvc.usd$ | async) || 0)) | formatCash }})
          }
        </p>
        <div
          class="sale-date"
          tippy
          [options]="item.saleDateTippyOptions">
          {{ (+item.blockTimestamp * 1000) | timeago : true }}
        </div>
      </ng-container>

      <ng-container *ngIf="shallowValue && !showSaleDate">
        <p i18n>
          {{ (item.value | weiToEth) | formatCash }}Ξ
          @if (eventUsd && item.usd && item.usd !== '0') {
            <br />${{ ((item.value | weiToEth) | usd : item.usd) | formatCash }}
          } @else if (!eventUsd) {
            <br />${{ ((item.value | weiToEth) * ((dataSvc.usd$ | async) || 0)) | formatCash }}
          }
        </p>
      </ng-container>
    </div>

  </div>
</ng-template>

<ng-template #wrappedLogo>
  <svg width="50px" height="50px" viewBox="0 0 50 50" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><linearGradient x1="-35.7142%" y1="100.0002%" x2="485.714%" y2="100.0002%" id="linearGradient-5bgi0umd9h-1"><stop stop-color="#AB05F2" offset="0%"></stop><stop stop-color="#654AF7" offset="100%"></stop></linearGradient></defs><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><path d="M50,25 C50,38.8071 38.8071,50 25,50 C11.1929,50 0,38.8071 0,25 C0,11.1929 11.1929,0 25,0 C38.8071,0 50,11.1929 50,25 Z" id="Path" fill="url(#linearGradient-5bgi0umd9h-1)" fill-rule="nonzero"></path><path d="M35.0567,19.6862 C35.8411,19.6862 36.5471,19.7864 37.1749,19.9868 C37.3748,20.0506 37.5668,20.1246 37.7509,20.2087 C38.5128,20.5462 39.1007,21.036 39.5143,21.6782 C39.9279,22.3096 40.1348,23.0553 40.1348,23.9152 C40.1348,24.7752 39.9279,25.5208 39.5143,26.1522 C39.1007,26.7835 38.5128,27.2734 37.7509,27.6217 C37.5641,27.7044 37.3691,27.777 37.166,27.8394 C36.5404,28.0317 35.8373,28.1279 35.0567,28.1279 L33.0647,28.1279 L33.0647,31.1159 L29.8317,31.1159 L29.8317,19.6862 L35.0567,19.6862 Z M29.2512,17.0269 C29.4383,16.9862 29.6325,16.9648 29.8317,16.9648 L35.0567,16.9648 C36.3865,16.9648 37.6814,17.1878 38.8674,17.7269 C40.0599,18.258 41.0725,19.0756 41.7967,20.1961 C42.5354,21.3279 42.8561,22.6049 42.8561,23.9152 C42.8561,25.229 42.5336,26.5094 41.7906,27.6435 C41.0654,28.7505 40.058,29.5592 38.8823,30.0967 C38.8725,30.1012 38.8627,30.1056 38.8528,30.11 C37.8889,30.5368 36.8537,30.7591 35.786,30.8266 L35.786,31.1159 C35.786,32.6189 34.5676,33.8373 33.0647,33.8373 L29.8317,33.8373 C28.7678,33.8373 27.8465,33.2268 27.399,32.337 C26.9429,33.2462 26.0071,33.8373 24.9668,33.8373 L21.5052,33.8373 C20.596,33.8373 19.7672,33.3859 19.2682,32.666 C18.769,33.3864 17.9398,33.8373 17.0313,33.8373 L13.5697,33.8373 C12.3902,33.8373 11.3449,33.0774 10.9811,31.9554 L7.27458,20.5257 C7.00595,19.6973 7.14999,18.7904 7.66206,18.086 C8.17413,17.3816 8.99238,16.9648 9.86323,16.9648 L13.1942,16.9648 C14.1824,16.9648 15.0757,17.4981 15.5536,18.3298 C16.0319,17.4973 16.9257,16.9648 17.913,16.9648 L20.8847,16.9648 C21.8676,16.9648 22.7562,17.4922 23.236,18.3157 C23.7162,17.4916 24.6052,16.9648 25.5873,16.9648 L28.6733,16.9648 C28.8696,16.9648 29.0632,16.986 29.2512,17.0269 Z M19.3172,24.1601 L21.5052,31.1159 L24.9668,31.1159 L28.6733,19.6862 L25.5873,19.6862 L23.187,27.0502 L20.8847,19.6862 L17.913,19.6862 L15.4964,26.9849 L13.1942,19.6862 L9.86323,19.6862 L13.5697,31.1159 L17.0313,31.1159 L19.3172,24.1601 Z M33.0647,25.5807 L34.8608,25.5807 C34.9277,25.5807 34.9931,25.5792 35.0567,25.5764 C35.3306,25.564 35.5737,25.5249 35.786,25.4592 C35.9286,25.4151 36.0574,25.359 36.1722,25.2909 C36.2407,25.2502 36.3043,25.2053 36.363,25.1561 C36.7004,24.8622 36.8691,24.4486 36.8691,23.9152 C36.8691,23.3818 36.7004,22.9682 36.363,22.6743 C36.3005,22.6198 36.2323,22.5704 36.1586,22.5261 C36.0472,22.459 35.923,22.4035 35.786,22.3595 C35.5737,22.2913 35.3306,22.2507 35.0567,22.2379 C34.9931,22.2349 34.9277,22.2334 34.8608,22.2334 L33.0647,22.2334 L33.0647,25.5807 Z" id="Shape" fill="#FFFFFF"></path></g></svg>
</ng-template>


<ng-template #wrappedC721Logo>
  <span class="c721-logo">721</span>
</ng-template>

<ng-template #unwrappedLogo>
  <svg id="V1_08" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 210 178">
    <defs>
      <style>
        .my-st0 {
          fill: #fff;
          fill-rule: evenodd;
        }
  
        .my-st1 {
          fill: #a69afe;
        }
      </style>
    </defs>
    <rect class="my-st1" width="210" height="178"/>
    <path id="v1" class="my-st0" d="M48,97h14v-44h-14v44ZM107,97h14v-44h-14v44ZM62,112h15v-15h-15v15ZM92,112h15v-15h-15v15ZM77,126h15v-14h-15v14ZM148,68h-15v15h15v43h14V53h-14v15Z"/>
  </svg>
</ng-template>

<!-- Owner Bid Creation Modal -->
<app-bid-creation-modal
  [isActive]="ownerBidModalActive"
  [bidType]="'owner'"
  [ownerAddress]="ownerBidAddress"
  [punkIndices]="ownerBidPunkIndices"
  [filterTag]="ownerBidFilterTag"
  (modalClosed)="closeOwnerBidModal()"
  (bidCreated)="onOwnerBidCreated()">
</app-bid-creation-modal>

<!-- Bid Copy Confirmation Modal -->
<app-bid-copy-confirmation-modal
  [isActive]="copyConfirmationModalActive"
  [punkIds]="copyConfirmationPunkIds"
  (confirmed)="onCopyConfirmed()"
  (cancelled)="onCopyCancelled()">
</app-bid-copy-confirmation-modal>

<!-- Copy Bid Creation Modal -->
<app-bid-creation-modal
  [isActive]="copyBidModalActive"
  [bidType]="copyFromBidPayload?.bidType ?? 'collection'"
  [ownerAddress]="copyFromBidPayload?.ownerAddress ?? null"
  [punkIndices]="copyFromBidPayload?.punkIndices ?? []"
  [selectedPunkIds]="copyFromBidPayload?.selectedPunkIds ?? []"
  [activeTraits]="copyFromBidPayload?.activeTraits ?? []"
  [filterTag]="copyFromBidPayload?.filterTag ?? ''"
  [copyFromBid]="copyFromBidPayload"
  (modalClosed)="closeCopyBidModal()"
  (bidCreated)="onCopyBidCreated()">
</app-bid-creation-modal>

<!-- Select Punk for Bid Modal -->
<app-select-punk-modal
  [isActive]="selectPunkForBidModalActive"
  [bid]="selectedStashBid"
  [matchingPunkIds]="matchingPunkIdsForBid"
  (closed)="closeSelectPunkModal()"
  (punkSelected)="onPunkSelected($event)">
</app-select-punk-modal>

<app-confirmation-dialog
  [isActive]="cancelDialogActive"
  [title]="cancelDialogTitle"
  [message]="cancelDialogMessage"
  [confirmLabel]="cancelDialogConfirmLabel"
  [showCancelButton]="cancelDialogShowCancelButton"
  [destructive]="cancelDialogDestructive"
  (confirmed)="onOutgoingCancelDialogConfirmed()"
  (cancelled)="onOutgoingCancelDialogCancelled()">
</app-confirmation-dialog>
